// extracted by mini-css-extract-plugin
export default {"wrapper":"ChapterNavigationCard_wrapper__-lPPS","title":"ChapterNavigationCard_title__Yiakw","description":"ChapterNavigationCard_description__c5SBR"};